import { createAction, props, union } from '@ngrx/store';
import { RfrCplSearchQueryI } from 'src/app/api/rfr-cpl-search/rfr-cpl-search.query.int';
import { RfrCplItemI } from 'src/app/api/rfr-cpl-search/rfr-cpl-item.int';

export const load = createAction('[RFR CPL / Search] Get', props<{ query: RfrCplSearchQueryI }>());
export const received = createAction('[RFR CPL / Search] Received', props<{ data: RfrCplItemI[] }>());
export const reset = createAction('[RFR CPL / Search] Reset', props<Record<string, unknown>>());
export const error = createAction('[RFR CPL / Search] Error', props<{ messageText: string }>());

const all = union({ error, load, received, reset });
export type Actions = typeof all;
